import React from "react";
import { useNavigate } from "react-router-dom";

import css from "./ParticipantsNew.module.css";
import { UserContext } from "../../Context/UserContext";
import { Head } from "../../Utils/Head";
import { useForm } from "../../Hooks/useForm";
import { Button } from "../Forms/Button";
import { Input } from "../Forms/Input";
import { Error } from "../../Utils/Error";
import { createParticipantFirebase } from "../../Utils/firebaseResearch";
import { newId } from "../../Utils/newId";
import { ResearchContext } from "../../Context/ResearchContext";

export const ParticipantsNew = () => {
  const { loading, error } = React.useContext(UserContext);
  const { setParticipants } = React.useContext(ResearchContext);
  const name = useForm();
  const email = useForm("email");
  const [alertFirst, setAlertFirst] = React.useState("");
  const [alertEmail, setAlertEmail] = React.useState("");
  const navigate = useNavigate();

  function handleValidation() {
    let formIsValid = true;
    if (!name.value) {
      formIsValid = false;
      setAlertFirst("You need a first name");
    } else {
      setAlertFirst("");
    }
    if (!email.value) {
      formIsValid = false;
      setAlertEmail("You need a email");
    } else {
      setAlertEmail("");
    }
    return formIsValid;
  }

  async function handleSubmit() {
    const newParticipant = {
      id: newId(),
      name: name.value,
      email: email.value,
      createdAt: new Date().toISOString(),
    };
    setParticipants((prev) => [...prev, newParticipant]);
    createParticipantFirebase(newParticipant);
    navigate("/researcher/participants");
  }

  return (
    <>
      <section className={css.login}>
        <div></div>
        <div className={css.forms}>
          <Head title="Nova Conta" />
          <h2 className="title">Novo Participante</h2>
          {alertFirst && <p className={css.error}>{alertFirst}</p>}
          {alertEmail && <p className={css.error}>{alertEmail}</p>}
          <form
            className="form"
            onSubmit={(e) => {
              e.preventDefault();
              handleValidation() && handleSubmit();
            }}
          >
            <Input label="Nome completo" type="text" name="name" {...name} />
            <Input label="Email" type="email" name="email" {...email} />
            {loading ? (
              <Button disabled>Carregando...</Button>
            ) : (
              <Button>Enviar</Button>
            )}
            <Error error={error} />
          </form>
          <p></p>
        </div>
      </section>
    </>
  );
};
